import { PayrollStatus, PayrollType } from "@wingspanhq/wingspan-api-sdk";

export const PAYROLL_RUNS_YEARS = ["2024", "2025", "2026"] as const;
export const PAYROLL_RUNS_DEFAULT_YEAR: (typeof PAYROLL_RUNS_YEARS)[number] =
  "2026";

/**
 * The payroll type this screen lists. `filter[type][eq]` is REQUIRED by the v3
 * `listPayrolls` endpoint, and it is single-valued — so the screen commits to one
 * type. This is the W-2 employee payroll view (the paystubs carry tax
 * withholdings + employer contributions); switch to `CONTRACTOR_VENDOR` (or lift
 * to a filter/tab) if the contractor payroll view is added.
 */
export const PAYROLL_RUNS_TYPE: PayrollType = PayrollType.EMPLOYEE;

/**
 * Which v3 `PayrollStatus` values belong to each dashboard tab. No v3 field marks
 * a run "active" vs "historical", so we split by status: in-flight runs are still
 * being built/approved/paid; finished (or cancelled/failed) runs are history.
 */
export const PAYROLL_RUNS_ACTIVE_STATUSES: PayrollStatus[] = [
  PayrollStatus.DRAFT,
  PayrollStatus.PENDING_APPROVALS,
  PayrollStatus.FINALIZED,
  PayrollStatus.PROCESSING
];

export const PAYROLL_RUNS_HISTORY_STATUSES: PayrollStatus[] = [
  PayrollStatus.PAID,
  PayrollStatus.CANCELLED,
  PayrollStatus.FAILED
];

/** Ordered approval-window stages shown in the payroll run details stepper. */
export const PAYROLL_RUN_APPROVAL_STAGES = [
  "Open",
  "Approval",
  "Finalized",
  "Paid"
] as const;
